import { TableCellText } from '../TableCellText';
export function TableCellEmpty(props) {
    return <TableCellText aria-hidden="true" secondary="-" {...props}/>;
}
